import React, { Component } from 'react'
import './pagination.scss';

export default class Pagination extends Component {
    createList = () => {
        const children = [];

        if (this.props.pages < 10) {
            for (let i = 1; i <= this.props.pages; i++) {
                children.push(
                    <li className={ i === this.props.page ? 'page page-selected' : 'page' } onClick={ () => this.props.pageChange(i) } key={i}>
                        { i }
                    </li>
                )
            }
        } else {
            if (this.props.page !== 1) {
                children.push(
                    <li className={ 1 === this.props.page ? 'page page-selected' : 'page' } onClick={ () => this.props.pageChange(1) } key={1}>
                        1
                    </li>
                )

                if (this.props.page !== 2) {
                    children.push(
                        <li className="page" onClick={ () => this.props.pageChange(this.props.page - 1) } key={this.props.page - 1}>
                            &lt;
                        </li>
                    );
                }
            }

            children.push(
                <li className="page page-selected" onClick={ () => this.props.pageChange(this.props.page) } key={this.props.page}>
                    { this.props.page }
                </li>
            )

            if (this.props.page + 1 < this.props.pages) {
                children.push(
                    <li className="page" onClick={ () => this.props.pageChange(this.props.page + 1) } key={this.props.page + 1}>
                        &gt;
                    </li>
                )
            }

            if (this.props.page !== this.props.pages) {
                children.push(
                    <li className="page" onClick={ () => this.props.pageChange(this.props.pages) } key={this.props.pages}>
                        { this.props.pages }
                    </li>
                )
            }
        }

        return children;
    }

    render() {
        return (
            <ul className="pagination">
                { this.createList() }
            </ul>
        )
    }
}
